$(document).ready(function () {
  $(".pdp_description_inner.default_product.xbg ul li span").each(function () {
      $(this).replaceWith("<strong class='sp-str' style='" + ($(this).attr("style") || "") + "'>" + $(this).html() + "</strong>");
  });
});

$(document).ready(function () {
  $("h2").each(function () {
      if ($(this).html().trim() === "") {
          $(this).remove();
      }
  });
});
$(document).ready(function () {
  $("h4").each(function () {
      if ($(this).html().trim() === "") {
          $(this).remove();
      }
  });
});
$('h4').each(function() {
  if ($(this).children('br').length === $(this).contents().length) {
      $(this).remove();
  }
});


$(document).ready(function() {
    $('br').attr('aria-hidden','true');
    $('.pdp_description .pdp_description_inner h4').attr('aria-level','2');
    $('.pdp_description .pdp_description_inner h5').attr('aria-level','3');
    $('.pdp_description .pdp_description_inner h6').attr('aria-level','4');
    $('.pdp_them_section .pdp_them_table thead th svg').attr('aria-label','Plant People');
    $('.nav-item.first.has-mega-nav a, li.nav-item.dropdown.has-mega-nav a').removeAttr('href').attr('role','button').attr('tabindex','0');
    $('.add_cart_info_bt svg').attr('aria-hidden','true');
    $('a.shg-btn.shg-cse.rca-add-to-cart-submit').attr('tabindex','0').attr('role','button');
    $('textarea#CommentForm-body').attr('aria-label','comment');
    $('input#CommentForm-author').attr('aria-label','name');
    $('input#CommentForm-email').attr('aria-label','Email');
  
    $('a[href^="tel:"]').each(function () {
        var number = $(this).text().trim().replace('tel:', ''); 
        var ariaLabel = 'Phone Number: ' + number;
        
        $(this).attr('aria-label', ariaLabel);
    });
$('a[href^="mailto:"]').each(function () {
          var email = $(this).text().trim().replace('mailto:', '');
          var ariaLabel = 'Email Address: ' + email;
          
          $(this).attr('aria-label', ariaLabel);
});
$('.left_top_content_bottom .collapsible-panel-block-content table tr').each(function() {
    var $tr = $(this);
    var $td = $tr.find('td:first');
    if ($td.length) {
        var innerHTML = $td.html();
        var $th = $('<th scope="col"></th>').html(innerHTML).addClass($td.attr('class'));
        $td.replaceWith($th);
    }
});
$(".collapsible-panel-block-heading").each(function() {
    var $heading = $(this);
    var headingText = $heading.text().trim();
    var $table = $heading.next(".collapsible-panel-block-content").find("table");
    if ($table.length) {
      var $caption = $("<caption>").text(headingText).addClass("visually-hidden");;
      $table.prepend($caption);
    }
  });
  var $navs = $('nav.main-header--nav-compressed');

  if ($navs.length > 1) {
      $navs.eq(0).attr('aria-label', 'primary');
      $navs.eq(1).attr('aria-label', 'secondary');
  }
    $('.divide-blogs .tab').attr('role', 'tablist');
	    $('.divide-blogs .tab').attr('aria-label', 'Vehicle Overview and Comments');

    $('.divide-blogs .tab button')
        .attr('role', 'tab')
        .attr('aria-selected', 'false');
    $('.divide-blogs .tab button.tablinks.active').attr('aria-selected', 'true');

    $('.divide-blogs .tab button.tablinks').on('click', function (event) {
        event.preventDefault();
        $('.divide-blogs .tab button.tablinks')
            .removeClass('active')
            .attr('aria-selected', 'false');
        $(this)
            .addClass('active')
            .attr('aria-selected', 'true')
            .attr('role', 'tab');
    });
	  $('.accordion .accordion-item .accordion-header').click(function (e) {
    e.preventDefault();
    $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });
  });
  $('.accordion .accordion-content a').each(function() {
    if ($.trim($(this).html()) === '' || $(this).children().is('br')) {
        $(this).remove();
    }
});
var lastFocusedButton;

$(".product-card-interaction").on("click", function () {
  lastFocusedButton = $(this);
  setTimeout(function () {
    $(".quickshop-close").attr("tabindex", 0).focus();
  }, 1000);
});

$(".quickshop-close").on("click", function () {
  setTimeout(function () {
    if (lastFocusedButton) {
      lastFocusedButton.attr("tabindex", 0).focus();
    }
  }, 1000);
});
$('a').each(function () {
    if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'www.plantpeople.co') {
      var warningSpan = $('<span class="visually-hidden">: This will open in a new tab.</span>');
      $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
      $(this).append(warningSpan);
    }
  });

  $(".shogun-accordion-wrapper .shogun-accordion").each(function () {
    var $accordion = $(this);
    var inputTitle = $accordion.find("h4.shogun-accordion-title").text().trim();

    $accordion
        .find(".shogun-accordion-header h4")
        .attr("role", "button")
        .attr("aria-expanded", function () {
            return $(this).closest(".shogun-accordion").hasClass("shogun-accordion-active") ? "true" : "false";
        })
        .on("click", function () {
            var $this = $(this);
            var $accordionParent = $this.closest(".shogun-accordion h4");
            var isActive = $accordionParent.hasClass("shogun-accordion-active h4");

            $accordionParent.toggleClass("shogun-accordion-active", !isActive);

            $this.attr("aria-expanded", !isActive);
        });
});

});

$(document).ready(function () {
    setTimeout(function () {
        $('.hsa-products .shg-product-price').prepend('<span class="visually-hidden">Current Price:</span>');
        $(".hsa-products .shg-category-col").each(function() {
            var headingTitle = $(this).find("h3").text().trim();
            var linkTitle = $(this).find("a").text().trim();
            $(this).find("a").attr("aria-label", linkTitle + " : " + headingTitle);
        });
        $(".collapsible-panel-block-headings").click(function () {
          const isExpanded = $(this).attr("aria-expanded") === "true";
      
          $(this).toggleClass("active");
        
          $(this).attr("aria-expanded", isExpanded ? "false" : "true");
        
          if ($(this).hasClass("active")) {
            $(".blog_filter").css("display", "block");
          } else {
            $(".blog_filter").css("display", "none");
          }
        });
        $(document).keydown(function(e) {
          if (e.key === "Escape") {
            $(".collapsible-panel-block-headings").attr("aria-expanded", "false");
              $(".collapsible-panel-block-headings").removeClass("active");
              $(".blog_filter").css("display", "none");
          }
      });
    }, 3000);
}, 3000);

document.addEventListener('DOMContentLoaded', function () {
  const accordionButtons = document.querySelectorAll('.accordion-button');

  accordionButtons.forEach(button => {
    button.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true' || false;
      this.setAttribute('aria-expanded', !expanded);
      
      const content = this.nextElementSibling;
      if (expanded) {
        content.hidden = true;
      } else {
        content.hidden = false;
      }
    });
  });
});

$(document).ready(function () {
  $(".nav-item.first.has-mega-nav a").on("click", function (event) {
      event.preventDefault(); // Prevent default navigation if needed
      $('.nav-item.first.has-mega-nav').toggleClass("active");
      $('section#header-dropdown-shop-by-benefit').toggleClass('visible');
      $('.main-header--nav-links li:nth-child(2)').removeClass("active");
      $('section#header-dropdown-shop-by-type').removeClass('visible');
      $('.main-header--nav-links li:nth-child(4)').removeClass("active");
      $('section#header-dropdown-learn').removeClass('visible');
      $('.main-header--nav-links li:nth-child(4) a').attr('aria-expanded','false');
      $('.main-header--nav-links li:nth-child(2) a').attr('aria-expanded','false');

  });
});

$(document).ready(function () {
  $(".main-header--nav-links li:nth-child(2) a").on("click", function (event) {
      event.preventDefault(); // Prevent default navigation if needed
      $('.main-header--nav-links li:nth-child(2)').toggleClass("active");
      $('section#header-dropdown-shop-by-type').toggleClass('visible');
      $('.nav-item.first.has-mega-nav').removeClass("active");
      $('section#header-dropdown-shop-by-benefit').removeClass('visible');
      $('.main-header--nav-links li:nth-child(4)').removeClass("active");
      $('section#header-dropdown-learn').removeClass('visible');
      $('.nav-item.first.has-mega-nav a').attr('aria-expanded','false');
      $('.main-header--nav-links li:nth-child(4) a').attr('aria-expanded','false');
      
  });
});
$(document).ready(function () {
  $(".main-header--nav-links li:nth-child(4) a").on("click", function (event) {
      event.preventDefault(); // Prevent default navigation if needed
      $('.main-header--nav-links li:nth-child(4)').toggleClass("active");
      $('section#header-dropdown-learn').toggleClass('visible');
      $('.nav-item.first.has-mega-nav').removeClass("active");
      $('section#header-dropdown-shop-by-benefit').removeClass('visible');
      $('.main-header--nav-links li:nth-child(2)').removeClass("active");
      $('section#header-dropdown-shop-by-type').removeClass('visible');
      $('.nav-item.first.has-mega-nav a a').attr('aria-expanded','false');
      $('.main-header--nav-links li:nth-child(2) a').attr('aria-expanded','false');
  });
});


$(document).on("keydown", function (event) {
  if (event.key === "Escape") {
          $('.has-mega-nav.active').removeClass("active");
          $('section.mega-nav.visible').removeClass('visible');

  }
});


$(document).ready(function() {
  $('#header-dropdown-shop-by-benefit').insertAfter('.nav-item.first.has-mega-nav');
  $('section#header-dropdown-shop-by-type').insertAfter('li[aria-controls="header-dropdown-shop-by-type"]');
  $('section#header-dropdown-learn').insertAfter('li[aria-controls="header-dropdown-learn"]');
});

$(document).ready(function() {
  $('.has-mega-nav a').attr('aria-expanded','false');
  $('.has-mega-nav a').on('click', function(event) {
    // Prevent default link behavior if necessary
    event.preventDefault();
    
    // Toggle the 'aria-expanded' attribute between true and false
    var expanded = $(this).attr('aria-expanded') === 'true'; // Check if aria-expanded is true
    $(this).attr('aria-expanded', !expanded); // Toggle it to the opposite value
  });
  $(document).on("keydown", function (event) {
    if (event.key === "Escape") {
            $('.has-mega-nav a').attr('aria-expanded', 'false');
        }
});
});

$(document).ready(function() {
  $(".nav-item.first.has-mega-nav a.label").on("keydown", function(event) {
      if (event.key === "Enter") {
          event.preventDefault();
          $(this).closest(".nav-item.first.has-mega-nav").toggleClass("active");
          $("#header-dropdown-shop-by-benefit").toggleClass("visible");
      }
  });
  $(".nav-item.dropdown.has-mega-nav a.label").on("keydown", function(event) {
    if (event.key === "Enter") {
        event.preventDefault();
        let parentLi = $(this).closest(".nav-item.dropdown.has-mega-nav");
        parentLi.toggleClass("active");
        
        if (parentLi.attr("aria-controls") === "header-dropdown-shop-by-type") {
            $("#header-dropdown-shop-by-type").toggleClass("visible");
        } else if (parentLi.attr("aria-controls") === "header-dropdown-learn") {
            $("#header-dropdown-learn").toggleClass("visible");
        }
    }
});
});
